@if (heroCarousel.length) {
  <div class="hero-slider">
    <swiper-container #swiper init="false" class="full-width">
      @for (entry of heroCarousel; track entry) {
        <swiper-slide>
          <div class="slide" (click)="toggleEntry(entry)">
            <div class="image-container">
              <img [src]="entry.image" />
              <button (click)="slideNext($event)" class="right-button">
                <i class="fas fa-chevron-right"></i>
              </button>
            </div>
            <div class="description-container">
              <h2 class="title">{{entry.title}}</h2>
              <p class="description">{{ entry.description }}</p>
            </div>
          </div>
        </swiper-slide>
      }
    </swiper-container>
  </div>
}
